import apiClient from '@/plugins/axios';

export default {
	list(params, opts = {}) {
		return apiClient.get('v1/Move', {params, ...opts});
	},

	getMoves(params) {
		let query = '?';
		Object.entries(params).forEach(([key, value]) => {
			if (key === 'currentPage') {
				key = 'pageNumber';
			}

			query += value ? `${key}=${value}&` : '';
		});

		return apiClient.get(`v1/Move${query}`);
	},

	getMove(moveId) {
		return apiClient.get(`v1/Move/Get/${moveId}`);
	},

	getMoveSummary(moveId) {
		return apiClient.get(`v1/Move/MoveObjectSummary/${moveId}`);
	},

	createMove(move) {
		return apiClient.post('v1/MoveBuilding/StartMovingBuildings', move);
	},

	getBuildingsWithRoundPlannings(oldBuildingIds) {
		let list = '';
		
		oldBuildingIds.forEach((id, index) => {
			
			if (index != 0) {
				list += '&';
			}
			
			list += `oldBuildingIds=${id}`;
		});
		
		return apiClient.get(`v1/MoveBuilding/GetBuildingsWithRoundPlannings/?${list}`);
	},
	
	addRoundPlanningsToMove(roundPlannings, moveId) {
		return apiClient.put(`v1/MoveRoundPlanning/MoveRoundPlannings/${moveId}`, roundPlannings);
	},
	
	setKeepOnRoundPlannings(roundPlannings) {
		return apiClient.put('v1/MoveRoundPlanning/SetKeepOnRoundPlannings/', roundPlannings);
	},

	getRoundPlanningsWithFireProtections(moveId, oldRoundPlanningIds) {
		let list = '';
		
		oldRoundPlanningIds.forEach((id, index) => {
			
			if (index != 0) {
				list += '&';
			}
			
			list += `oldRoundPlanningIds=${id}`;
		});
		
		return apiClient.get(`v1/MoveRoundPlanning/GetRoundPlanningsWithFireProtections/?moveId=${moveId}&${list}`);
	},
	
	getFireProtectionsFromTargetCustomer(customerId) {
		return apiClient.get(`v1/MoveFireProtection/GetFireProtectionsFromTargetCustomer/${customerId}`);
	},
	
	addFireProtectionsToMove(fireProtections, moveId) {
		return apiClient.put(`v1/MoveFireProtection/MoveFireProtections/${moveId}`, fireProtections);
	},

	getRoundPlanningsWithQuestionLists(moveId, oldRoundPlanningIds) {
		let list = '';
		
		oldRoundPlanningIds.forEach((id, index) => {
			
			if (index != 0) {
				list += '&';
			}
			
			list += `oldRoundPlanningIds=${id}`;
		});
		
		return apiClient.get(`v1/MoveRoundPlanning/GetRoundPlanningsWithQuestionLists/?moveId=${moveId}&${list}`);
	},

	getQuestionListsFromTargetCustomer(customerId) {
		return apiClient.get(`v1/MoveQuestionList/GetQuestionListsfromTargetCustomer/${customerId}`);
	},
	
	addQuestionListsToMove(questionLists, moveId) {
		return apiClient.put(`v1/MoveQuestionList/MoveQuestionLists/${moveId}`, questionLists);
	},
	
	getRoundPlanningsWithRoles(moveId, oldRoundPlanningIds) {
		let list = '';
		
		oldRoundPlanningIds.forEach((id, index) => {
			
			if (index != 0) {
				list += '&';
			}
			
			list += `oldRoundPlanningIds=${id}`;
		});
		
		return apiClient.get(`v1/MoveRoundPlanning/GetRoundPlanningsWithRoles/?moveId=${moveId}&${list}`);
	},
	
	addRolesToMove(roles, moveId) {
		return apiClient.put(`v1/MoveRole/MoveRoles/${moveId}`, roles);
	},
	
	getRoundPlanningsWithQuestions(moveId, oldRoundPlanningIds) {
		let list = '';
		
		oldRoundPlanningIds.forEach((id, index) => {
			
			if (index != 0) {
				list += '&';
			}
			
			list += `oldRoundPlanningIds=${id}`;
		});
		
		return apiClient.get(`v1/MoveRoundPlanning/GetRoundPlanningsWithQuestions/?moveId=${moveId}&${list}`);
	},
	
	addQuestionsToMove(questions, moveId) {
		return apiClient.put(`v1/MoveQuestion/MoveQuestions/${moveId}`, questions);
	},
	
	getUsers(buildingId) {
		return apiClient.get(`v1/User/?buildingId=${buildingId}`);
	},
	
	addUsersToMove(users, moveId) {
		return apiClient.put(`v1/MoveUser/MoveUsers/${moveId}`, users);
	},
	
	executeMove(moveId) {
		return apiClient.put(`v1/Move/ExecuteMove/${moveId}`);
	},
	
	approveMove(moveId) {
		return apiClient.put(`v1/Move/ApproveMove/${moveId}`);
	},
	
	rollbackMove(moveId) {
		return apiClient.put(`v1/Move/RollbackMove/${moveId}`);
	},
	

	updateMove(move) {
		var moveId = move.id;

		return apiClient.put(`v1/Move/${moveId}`, move);
	},

	deleteMove(moveId) {
		return apiClient.delete(`v1/Move/${moveId}`);
	}
};
